module.exports = __webpack_public_path__ + "img/error-accessories.82cb4d1c.png";